/**
 * App Configuration
 * 
 * Configuration settings for the application
 */

export const APP_CONFIG = {
  // Enable/disable password gate
  // Set to false to disable password protection
  // Can also be controlled via REACT_APP_ENABLE_PASSWORD_GATE environment variable
  ENABLE_PASSWORD_GATE: process.env.REACT_APP_ENABLE_PASSWORD_GATE !== 'false',
};

